import { OneError } from '#/errors/oneError';

import { useFallback } from './Fallback.hook';
import { Status } from './Status';

interface FallbackProps {
  error?: Error | OneError;
  componentStack?: string;
}

export const Fallback = ({ error, componentStack }: FallbackProps) => {
  const statusProps = useFallback(error);

  return (
    <Status {...statusProps} componentStack={componentStack} error={error} />
  );
};
